var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundBellIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F6F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 20.5C18.625 21.9497 17.4497 23.125 16 23.125C14.5503 23.125 13.375 21.9497 13.375 20.5",
    stroke: "#1E201C",
    strokeWidth: 1.125,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4233 20.5H10.5767C9.84396 20.5 9.25 19.906 9.25 19.1733C9.25 18.8215 9.38977 18.4841 9.63857 18.2352L10.75 17.1238V14.125C10.75 11.2255 13.1005 8.875 16 8.875C18.8995 8.875 21.25 11.2255 21.25 14.125V17.1238L22.3614 18.2352C22.6102 18.4841 22.75 18.8215 22.75 19.1733C22.75 19.906 22.156 20.5 21.4233 20.5Z",
    stroke: "#1E201C",
    strokeWidth: 1.125,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundBellIcon);
export default __webpack_public_path__ + "static/media/round-bell-icon.01dc162d39de09ac6b968d45ce2ee74d.svg";
export { ForwardRef as ReactComponent };